import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../loader/loader';
import NotAuthorized from '../notAuthorized/notAuthorized';
import { validateToken } from '../../API/server/validateToken';
import getCondominioData from '../../API/server/getCondominios';

const PrivateRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('user')) {
      setIsAuthorized(true);
      setIsLoading(false);
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    console.log('Parâmetro recebido:', { token });

    if (!token) {
      console.warn('Token ausente ou inválido!');
      setIsAuthorized(false);
      setIsLoading(false);
      // navigate('/');
      return;
    }

    validateToken({ token })
      .then(async (res) => {
        if (res?.user) sessionStorage.setItem('user', JSON.stringify(res.user));
        if (res?.condominio) sessionStorage.setItem('condominio', JSON.stringify(res.condominio));

        const condominioData = await getCondominioData();
        const { message, ...dataWithoutMessage } = condominioData;
        sessionStorage.setItem('condominioInfo', JSON.stringify(dataWithoutMessage));

        setIsAuthorized(true);

        window.history.replaceState({}, document.title, location.pathname);
      })
      .catch((error) => {
        console.error('Erro na validação do token:', error);
        setIsAuthorized(false);
        navigate('/');
      })
      .finally(() => setIsLoading(false));
  }, [location.search, location.pathname, navigate]);

  if (isLoading) return <Loader />;

  return isAuthorized ? children : <NotAuthorized />;
};

export default PrivateRoute;